export const SET_FOLDER_LIST = 'data-management/SET_FOLDER_LIST';
export const UNSET_FOLDER_LIST = 'data-management/UNSET_FOLDER_LIST';
export const SET_FOLDER_LIST_LOADING = 'data-management/SET_FOLDER_LIST_LOADING';
export const SET_TABLE_SCHEMA = 'data-management/SET_TABLE_SCHEMA';
export const SET_TABLE_TOGGLE_COLUMNS = 'data-management/SET_TABLE_TOGGLE_COLUMNS';
export const SET_TABLE_CONVERT_MAP = 'data-management/SET_TABLE_CONVERT_MAP';
export const SET_TABLE_VIEW_LOADING = 'data-management/SET_TABLE_VIEW_LOADING';
export const SET_TABLE_DATA_LOADING = 'data-management/SET_TABLE_DATA_LOADING';
export const SET_TABLE_DATA = 'data-management/SET_TABLE_DATA';
export const SET_TABLE_FIELDS = 'data-management/SET_TABLE_FIELDS';
export const SET_TABLE_DATA_PERMISSIONS = 'data-management/SET_TABLE_DATA_PERMISSIONS';
export const SET_TABLE_VIEW_SCHEMA = 'data-management/SET_TABLE_VIEW_SCHEMA';
export const UPDATE_TABLE_DATA = 'data-management/UPDATE_TABLE_DATA';
export const INSERT_ITEM_IN_SCHEMA = 'data-management/INSERT_ITEM_IN_SCHEMA';
export const ADD_NEW_ROW_IN_TABLE = 'data-management/ADD_NEW_ROW_IN_TABLE';
export const SET_TABLE_ROW = 'data-management/SET_TABLE_ROW';
export const SHOW_FIELD_MODAL = 'data-management/SHOW_FIELD_MODAL';
export const HIDE_FIELD_MODAL = 'data-management/HIDE_FIELD_MODAL';
export const ADD_FIELD = 'data-management/ADD_FIELD';
export const UPDATE_FIELD = 'data-management/UPDATE_FIELD';
export const UPDATE_FIELD_POSITION = 'data-management/UPDATE_FIELD_POSITION';
export const DELETE_FIELD = 'data-management/DELETE_FIELD';
export const SHOW_CREATE_RECORD_MODAL = 'data-management/SHOW_CREATE_RECORD_MODAL';
export const DELETE_IMPORT_ROW = 'data-management/DELETE_IMPORT_ROW';
export const HIDE_CREATE_RECORD_MODAL = 'data-management/HIDE_CREATE_RECORD_MODAL';
export const HIDE_CREATE_FILTER_MODAL = 'data-management/HIDE_CREATE_FILTER_MODAL';
export const SET_EDIT_FILTER_MODAL_LOADING = 'data-management/HIDE_CREATE_FILTER_MODAL';
export const SET_EDIT_MODAL_LOADING = 'data-management/SET_EDIT_MODAL_LOADING';
export const SHOW_CREATE_FILTER_MODAL = 'data-management/SHOW_CREATE_FILTER_MODAL';
export const ADD_NEW_RECORD = 'data-management/ADD_NEW_RECORD';
export const SHOW_FOLDER_MODAL = 'data-management/folders/SHOW_FOLDER_MODAL';
export const HIDE_MODULE_MODAL = 'data-management/folders/HIDE_MODULE_MODAL';
export const SHOW_MODULE_MODAL = 'data-management/folders/SHOW_MODULE_MODAL';
export const UPDATE_FOLDER = 'data-management/folders/UPDATE_FOLDER';
export const UPDATE_FOLDER_TABLE = 'data-management/folders/UPDATE_FOLDER_TABLE';
export const UPDATE_MODULE = 'data-management/folders/UPDATE_MODULE';
export const HIDE_FOLDER_MODAL = 'data-management/folders/HIDE_FOLDER_MODAL';
export const SET_MODAL_LOADING = 'data-management/folders/SET_MODAL_LOADING';
export const SET_MODULE_MODAL_LOADING = 'data-management/folders/SET_MODULE_MODAL_LOADING';
export const ADD_FOLDER = 'data-management/folders/ADD_FOLDER';
export const ADD_FOLDER_TABLE = 'data-management/folders/ADD_FOLDER_TABLE';
export const ADD_MODULE = 'data-management/folders/ADD_MODULE';
export const DELETE_FOLDER = 'data-management/folders/DELETE_FOLDER';
export const DELETE_TABLE = 'data-management/folders/DELETE_TABLE';
export const SET_FOLDER_DATA_LOADING = 'data-management/folders/SET_FOLDER_DATA_LOADING';
export const SET_FOLDER_DATA = 'data-management/folders/SET_FOLDER_DATA';
export const SET_FOLDERS_DATA = 'data-management/folders/SET_FOLDERS_DATA';
export const SET_FOLDER_DATA_PERMISSIONS = 'data-management/folders/SET_FOLDER_DATA_PERMISSIONS';
export const UPDATE_PAGINATION = 'data-management/folders/UPDATE_PAGINATION';
export const SET_TABLES = 'data-management/SET_TABLES';
export const SET_BUILDER_LOADING = 'data-management/SET_BUILDER_LOADING';
export const SET_FIELD_DATA = 'data-management/SET_FIELD_DATA';
export const SET_FIELD_DATA_LOADING = 'data-management/SET_FIELD_DATA_LOADING';
export const SET_MODULE_LIST_LOADING = 'data-management/SET_MODULE_LIST_LOADING';
export const SET_MODULE_LIST = 'data-management/SET_MODULE_LIST';
export const UNSET_MODULE_LIST = 'data-management/UNSET_MODULE_LIST';
export const DELETE_MODULE = 'data-management/DELETE_MODULE';
export const SET_RECYCLE_BIN_LOADING = 'data-management/SET_RECYCLE_BIN_LOADING';
export const SET_RECYCLE_BIN_DATA = 'data-management/SET_RECYCLE_BIN_DATA';
export const SET_FOLDER_LIST_MODULE = 'data-management/SET_FOLDER_LIST_MODULE';
export const SET_MODULE_DATA_LOADING = 'data-management/SET_MODULE_DATA_LOADING';
export const SET_MODULE_DATA = 'data-management/SET_MODULE_DATA';
export const SET_MODULE_DATA_PERMISSIONS = 'data-management/SET_MODULE_DATA_PERMISSIONS';
export const SHOW_PERMISSIONS_MODAL = 'data-management/folders/SHOW_PERMISSIONS_MODAL';
export const HIDE_PERMISSIONS_MODAL = 'data-management/folders/HIDE_PERMISSIONS_MODAL';
export const SET_FIELDS = 'data-management/SET_FIELDS';
export const SHOW_VIEW_RECORD_MODAL = 'data-management/SHOW_VIEW_RECORD_MODAL';
export const HIDE_VIEW_RECORD_MODAL = 'data-management/HIDE_VIEW_RECORD_MODAL';
export const TOGGLE_VIEW_RECORD_MODAL = 'data-management/TOGGLE_VIEW_RECORD_MODAL';
export const SET_VIEW_RECORD_MODAL_DATA = 'data-management/SET_VIEW_RECORD_MODAL_DATA';

export const SHOW_IMPORT_MODAL = 'data-management/SHOW_IMPORT_MODAL';
export const HIDE_IMPORT_MODAL = 'data-management/HIDE_IMPORT_MODAL';
export const SHOW_IMPORT_TABLE_VIEW_MODAL = 'data-management/SHOW_IMPORT_TABLE_VIEW_MODAL';
export const UPDATE_IMPORT_TABLE_VIEW_MODAL_ITEMS = 'data-management/UPDATE_IMPORT_TABLE_VIEW_MODAL_ITEMS';
export const UPDATE_IMPORT_REVIEW = 'data-management/UPDATE_IMPORT_REVIEW';
export const UPDATE_IMPORT_LOOKUP_OPTION = 'data-management/UPDATE_IMPORT_LOOKUP_OPTION';
export const HIDE_IMPORT_TABLE_VIEW_MODAL = 'data-management/HIDE_IMPORT_TABLE_VIEW_MODAL';
export const TOGGLE_TABLE_VIEW_MODAL_LOADING = 'data-management/TOGGLE_TABLE_VIEW_MODAL_LOADING';
export const BULK_UPDATE_CHECKS_SET = 'data-management/BULK_UPDATE_CHECKS_SET';
export const BULK_UPDATE_CHECKS_UNSET = 'data-management/BULK_UPDATE_CHECKS_UNSET';

export const GET_TABLE_DATA = 'data-management/GET_TABLE_DATA';
export const GET_TODO_USER_LIST = 'data-management/GET_TODO_USER_LIST';
export const TOGGLE_TODO_LIST_TABLE_LOADING = 'data-management/SET_DATA';

export const SET_MODAL_FIELDS = 'data-management/SET_MODAL_FIELDS';
export const UPDATE_LOOKUP_OPTION = 'data-management/UPDATE_LOOKUP_OPTION';

export const GET_PERMISSIONS_BY_OBJECT = 'data-management/GET_PERMISSIONS_BY_OBJECT';

export const SHOW_DATA_MANAGEMENT_MODAL = 'data-management/SHOW_DATA_MANAGEMENT_MODAL';
export const HIDE_DATA_MANAGEMENT_MODAL = 'data-management/HIDE_DATA_MANAGEMENT_MODAL';
export const TOGGLE_DATA_MANAGEMENT_MODAL = 'data-management/TOGGLE_DATA_MANAGEMENT_MODAL';

export const PROCESS_PROGRESS_BAR = 'data-management/PROCESS_PROGRESS_BAR';
export const UPDATE_TABLE_ITEMS = 'data-management/UPDATE_TABLE_ITEMS';
export const UPDATE_PAGINATION_PARAMS = 'data-management/UPDATE_PAGINATION_PARAMS';
export const SET_POWER_APPS_ENTITY = 'data-management/SET_POWER_APPS_ENTITY';
export const SET_POWER_BI_REPORT_ENTITY = 'data-management/SET_POWER_BI_REPORT_ENTITY';

export const ADD_MDM_VIEW = 'data-management/ADD_MDM_VIEW';
export const UPDATE_MDM_VIEW = 'data-management/UPDATE_MDM_VIEW';
export const DELETE_MDM_VIEW = 'data-management/DELETE_MDM_VIEW';
export const MDM_VIEW_MARK_DEFAULT = 'data-management/MDM_VIEW_MARK_DEFAULT';
export const SELECT_MDM_VIEW = 'data-management/SELECT_MDM_VIEW';
export const RESET_MDM_VIEWS = 'data-management/RESET_MDM_VIEWS';

export const SHOW_TODO_LIST_MODAL = 'data-management/SHOW_TODO_LIST_MODAL';
export const HIDE_TODO_LIST_MODAL = 'data-management/HIDE_TODO_LIST_MODAL';
export const SET_LOADING = 'data-management/SET_LOADING';
export const SET_PAGEDDATA_LOOKUP_VALUES_LOADING = 'data-management/SET_PAGEDDATA_LOOKUP_VALUES_LOADING';
export const SET_ALL_FIELDS = 'data-management/SET_ALL_FIELDS';
export const SET_CURRENT_FOLDER = 'data-management/SET_CURRENT_FOLDER';

export const SET_ORCHESTRATION = 'orchestration/SET_ORCHESTRATION';
export const SET_ORCHESTRATION_LOADING = 'orchestration/SET_ORCHESTRATION_LOADING';

export const UPDATE_TODO_LIST_CONFIG = 'data-management/UPDATE_TODO_LIST_CONFIG';

export const OPEN_CONTEXT_MENU = 'data-management/OPEN_CONTEXT_MENU';
export const CLOSE_CONTEXT_MENU = 'data-management/CLOSE_CONTEXT_MENU';
export const SET_LOOKUP_VALUES = 'data-management/SET_LOOKUP_VALUES';
export const SET_DEFAULT_LOOKUP_VALUES = 'data-management/SET_DEFAULT_LOOKUP_VALUES';
// TODO: store the first fifty lookup options to improve performance and avoid additional calls when switching pagination
// export const SET_FIRST_FIFTY_LOOKUP_VALUES = 'data-management/SET_FIRST_FIFTY_LOOKUP_VALUES';
export const UPDATE_FUZZY_LIST= 'data-management/UPDATE_FUZZY_LIST';
export const REMOVE_ELEMENT_FROM_FUZZY_LIST= 'data-management/REMOVE_ELEMENT_FROM_FUZZY_LIST';
export const CREATE_FUZZY_CONFIG= 'data-management/CREATE_FUZZY_CONFIG';
export const ADD_KEYS_FOR_FUZZY_CONFIG_ITEMS= 'data-management/ADD_KEYS_FOR_FUZZY_CONFIG_ITEMS';
export const REMOVE_CONFIG_IF_FUZZY_DID_NOT_SELECTED = 'data-management/REMOVE_CONFIG_IF_FUZZY_DID_NOT_SELECTED';
export const TRANSFORM_FUZZY_CONFIG = 'data-management/TRANSFORM_FUZZY_CONFIG';

export const RESET_DEFAULT_OPTIONS = 'data-management/RESET_DEFAULT_OPTIONS';
export const FIELD_OPTIONS = 'data-management/FIELD_OPTIONS';
export const RESET_TABLE_DATA = 'data-management/RESET_TABLE_DATA';
export const ADD_SELECTED_VALUE_TO_DEFAULT_FIELDS = 'data-management/ADD_SELECTED_VALUE_TO_DEFAULT_FIELDS';
export const ADD_MULTISELECT_REFS_TO_STORE = 'data-management/ADD_MULTISELECT_REFS_TO_STORE';

export const UPDATE_TABLE_FIELD_IS_CALCULATED_STATE = 'data-management/UPDATE_TABLE_FIELD_IS_CALCULATED_STATE';
export const UPDATE_CALCULATIONS = 'data-management/UPDATE_CALCULATIONS';

export const SET_FIELD_ITEM_CALCULATION_LOADING_STATE = 'data-management/SET_FIELD_ITEM_CALCULATION_LOADING_STATE';

// Mutation types for the view upload history modal
export const SET_UPLOAD_HISTORY_LOADING = 'data-management/SET_UPLOAD_HISTORY_LOADING';
export const SET_UPLOAD_HISTORY_DATA = 'data-management/SET_UPLOAD_HISTORY_DATA';
export const UPDATE_UPLOAD_HISTORY_PAGINATION = 'data-management/UPDATE_UPLOAD_HISTORY_PAGINATION';
export const UPDATE_FULL_UPLOAD_DATA = 'data-management/UPDATE_FULL_UPLOAD_DATA';